import {onBlockLoaded} from "@plaudit/frontend-apis";

onBlockLoaded({
	blockOrClassName: "plaudit-query-loop/reset-link",
	onAdd(element) {
		if (element instanceof HTMLButtonElement) {
			element.addEventListener('click', () => element.dispatchEvent(new Event(element.value || "clear", {bubbles: true, cancelable: true})));
		}
	}
});
